module.exports = __webpack_public_path__ + "img/gis-home.ac5c6ecf.svg";